import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'
import { Link } from 'gatsby'

import logo from '../../../images/logo.svg'

const styles = (theme) => {
  return createStyles({
    logo: {
      marginBottom: '3rem',
      maxWidth: '14.625rem',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
  })
}

const Logo = ({ classes }) => {
  return (
    <Link to="/">
      <img src={logo} alt="Tinkercodes" className={classes.logo} />
    </Link>
  )
}

export default withStyles(styles)(Logo)
